var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm.pedido != null
          ? _c("div", { staticClass: "layout__title" }, [
              _c("h3", [_vm._v("Venta " + _vm._s(_vm.pedido.numero_documento))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                attrs: { for: "verAuditoria" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.verAuditoria,
                      expression: "verAuditoria"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "verAuditoria",
                    id: "verAuditoria"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.verAuditoria)
                      ? _vm._i(_vm.verAuditoria, null) > -1
                      : _vm.verAuditoria
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.verAuditoria,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.verAuditoria = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.verAuditoria = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.verAuditoria = $$c
                      }
                    }
                  }
                }),
                _c("span", [_vm._v("Ver auditoría")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pedido != null && !_vm.editMode,
                    expression: "pedido != null && !editMode"
                  }
                ],
                staticClass: "btn-info btn--text",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$modal.show("editarCoordenadas")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-map-marker" }),
                _c("span", [_vm._v("Editar coordenadas")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary btn--text",
                attrs: { type: "button" },
                on: { click: _vm.verGaleria }
              },
              [
                _c("i", { staticClass: "fa fa-picture-o" }),
                _c("span", [_vm._v("Galería")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "btn-warning btn--text",
                attrs: { type: "button" },
                on: { click: _vm.verComentarios }
              },
              [
                _c("i", { staticClass: "fa fa-comment" }),
                _c("span", [_vm._v("Comentarios")])
              ]
            ),
            _vm._v(" "),
            _vm.pedido != null
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.editMode &&
                          _vm.puedeEditarPedido &&
                          _vm.pedido.estado !== "A",
                        expression:
                          "!editMode && puedeEditarPedido && pedido.estado !== 'A'"
                      }
                    ],
                    staticClass: "btn-primary btn--text",
                    on: { click: _vm.editar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-edit" }),
                    _c("span", [_vm._v("Editar")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pedido != null
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.editMode &&
                          _vm.puedeEditarPedido &&
                          _vm.pedido.estado !== "A",
                        expression:
                          "!editMode && puedeEditarPedido && pedido.estado !== 'A'"
                      }
                    ],
                    staticClass: "btn-success btn--text",
                    on: { click: _vm.editarAbonos }
                  },
                  [
                    _c("i", { staticClass: "fa fa-money" }),
                    _c("span", [_vm._v("Abonos")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cliente == null,
                    expression: "cliente == null"
                  }
                ],
                staticClass: "btn-info btn--text",
                attrs: { type: "button" },
                on: { click: _vm.imprimir }
              },
              [
                _c("i", { staticClass: "fa fa-print" }),
                _c("span", [_vm._v("Imprimir")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger btn--text",
                attrs: { type: "button" },
                on: { click: _vm.imprimirKardex }
              },
              [
                _c("i", { staticClass: "fa fa-print" }),
                _c("span", [_vm._v("Kardex")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.pedido != null
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _c("tbody", [
                    _c("tr", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.fecha) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field" }, [
                              _c(
                                "div",
                                { staticClass: "datepicker-field" },
                                [
                                  _c("VueCtkDateTimePicker", {
                                    attrs: {
                                      id: "desde",
                                      locale: "es",
                                      "no-label": "",
                                      "button-now-translation": "Ahora",
                                      format: "YYYY-MM-DD HH:mm",
                                      formatted: "YYYY-MM-DD HH:mm",
                                      label: "Seleccione fecha..."
                                    },
                                    model: {
                                      value: _vm.form.fecha,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha", $$v)
                                      },
                                      expression: "form.fecha"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errores.fecha
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.errores.fecha[0]))
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "form-field select" }, [
                          _c("div", { staticClass: "select-field" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.dia_cobro,
                                    expression: "form.dia_cobro"
                                  }
                                ],
                                attrs: {
                                  disabled: !_vm.editMode,
                                  id: "dia_cobro"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.form,
                                      "dia_cobro",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { disabled: "", value: "" } },
                                  [_vm._v("Seleccione...")]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("Lunes")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("Martes")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "3" } }, [
                                  _vm._v("Miércoles")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "4" } }, [
                                  _vm._v("Jueves")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "5" } }, [
                                  _vm._v("Viernes")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "6" } }, [
                                  _vm._v("Sábado")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "7" } }, [
                                  _vm._v("Domingo")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errores.dia_cobro
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.dia_cobro[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.vendedor.descripcion) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select2" }, [
                              _c(
                                "div",
                                { staticClass: "select2-field" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      id: "vendedorPedido",
                                      placeholder: "Seleccione...",
                                      options: _vm.vendedores,
                                      label: "descripcion"
                                    },
                                    on: {
                                      search: _vm.onSearchVendedores,
                                      input: _vm.inputVendedor
                                    },
                                    model: {
                                      value: _vm.selectedVendedor,
                                      callback: function($$v) {
                                        _vm.selectedVendedor = $$v
                                      },
                                      expression: "selectedVendedor"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errores.vendedor_id
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.vendedor_id[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.cliente.descripcion) +
                                  "\n                  "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-info btn--text",
                                  attrs: { type: "button" },
                                  on: { click: _vm.verInfoCliente }
                                },
                                [_c("i", { staticClass: "fa fa-info" })]
                              )
                            ])
                          : _c("div", { staticClass: "form-field select2" }, [
                              _c(
                                "div",
                                { staticClass: "select2-field" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      id: "clientePedido",
                                      placeholder: "Seleccione...",
                                      options: _vm.clientes,
                                      label: "descripcion"
                                    },
                                    on: {
                                      search: _vm.onSearchClientes,
                                      input: _vm.inputCliente
                                    },
                                    model: {
                                      value: _vm.selectedCliente,
                                      callback: function($$v) {
                                        _vm.selectedCliente = $$v
                                      },
                                      expression: "selectedCliente"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errores.cliente_id
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.cliente_id[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("td", [
                        _vm.pedido.cliente.coordenadas_cliente != null
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-info btn--text",
                                attrs: { type: "button" },
                                on: { dblclick: _vm.verDireccionCliente }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.pedido.cliente.direccion) +
                                    "\n                "
                                )
                              ]
                            )
                          : _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.cliente.direccion) +
                                  "\n                "
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.pedido.direccion_venta != null &&
                                  _vm.pedido.direccion_venta != "",
                                expression:
                                  "pedido.direccion_venta != null && pedido.direccion_venta != ''"
                              }
                            ],
                            staticClass: "btn-info btn--text",
                            attrs: { type: "button" },
                            on: { dblclick: _vm.verDireccionVenta }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.pedido.direccion_venta) +
                                "\n                "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.verAuditoria,
                              expression: "verAuditoria"
                            }
                          ]
                        },
                        [_c("strong", [_vm._v("Observación:")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.verAuditoria,
                              expression: "verAuditoria"
                            }
                          ]
                        },
                        [
                          !_vm.editMode
                            ? _c("span", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.pedido.observacion) +
                                    "\n                "
                                )
                              ])
                            : _c(
                                "div",
                                { staticClass: "form-field" },
                                [
                                  _c(
                                    "textarea-field",
                                    {
                                      attrs: {
                                        placeholder:
                                          "Escriba una observación...",
                                        id: "observacion"
                                      },
                                      model: {
                                        value: _vm.form.observacion,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "observacion", $$v)
                                        },
                                        expression: "form.observacion"
                                      }
                                    },
                                    [
                                      _vm.errores.observacion
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "helper-text text-danger",
                                              attrs: { slot: "helper" },
                                              slot: "helper"
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errores.observacion[0]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: _vm.verAuditoria ? 1 : 3 } },
                        [
                          !_vm.editMode
                            ? _c("span", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.pedido.observacion_modificacion
                                    ) +
                                    "\n                "
                                )
                              ])
                            : _c(
                                "div",
                                { staticClass: "form-field" },
                                [
                                  _c(
                                    "textarea-field",
                                    {
                                      attrs: {
                                        placeholder:
                                          "Escriba una observación de modificación...",
                                        id: "observacion_modificacion"
                                      },
                                      model: {
                                        value:
                                          _vm.form.observacion_modificacion,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "observacion_modificacion",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.observacion_modificacion"
                                      }
                                    },
                                    [
                                      _vm.errores.observacion_modificacion
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "helper-text text-danger",
                                              attrs: { slot: "helper" },
                                              slot: "helper"
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errores
                                                      .observacion_modificacion[0]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.pedido.ruta != null
                                      ? _vm.pedido.ruta.descripcion
                                      : _vm.pedido.visita.ruta.descripcion
                                  ) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select2" }, [
                              _c(
                                "div",
                                { staticClass: "select2-field" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      id: "ruta_id",
                                      options: _vm.rutas,
                                      label: "descripcion"
                                    },
                                    on: {
                                      input: _vm.inputRuta,
                                      search: _vm.onSearchRutas
                                    },
                                    model: {
                                      value: _vm.selectedRuta,
                                      callback: function($$v) {
                                        _vm.selectedRuta = $$v
                                      },
                                      expression: "selectedRuta"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm._m(8),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.supervisor.descripcion) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select2" }, [
                              _c(
                                "div",
                                { staticClass: "select2-field" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      placeholder: "Seleccione...",
                                      options: _vm.supervisores,
                                      id: "supervisor",
                                      name: "supervisor",
                                      label: "nombre"
                                    },
                                    on: {
                                      input: _vm.inputSupervisor,
                                      search: _vm.searchSupervisores
                                    },
                                    model: {
                                      value: _vm.selectedSupervisor,
                                      callback: function($$v) {
                                        _vm.selectedSupervisor = $$v
                                      },
                                      expression: "selectedSupervisor"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errores.supervisor_id
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.supervisor_id[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(9),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.pedido.verificador != null
                                      ? _vm.pedido.verificador.descripcion
                                      : ""
                                  ) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select2" }, [
                              _c(
                                "div",
                                { staticClass: "select2-field" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      placeholder: "Seleccione...",
                                      options: _vm.verificadores,
                                      id: "verificador",
                                      name: "verificador",
                                      label: "descripcion"
                                    },
                                    on: {
                                      input: _vm.inputVerificador,
                                      search: _vm.searchVerificadores
                                    },
                                    model: {
                                      value: _vm.selectedVerificador,
                                      callback: function($$v) {
                                        _vm.selectedVerificador = $$v
                                      },
                                      expression: "selectedVerificador"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errores.verificador_id
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.verificador_id[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _vm._m(10),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.recaudador.descripcion) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select2" }, [
                              _c(
                                "div",
                                { staticClass: "select2-field" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      placeholder: "Seleccione...",
                                      options: _vm.recaudadores,
                                      id: "recaudador",
                                      name: "recaudador",
                                      label: "nombre"
                                    },
                                    on: {
                                      input: _vm.inputRecaudador,
                                      search: _vm.searchRecaudadores
                                    },
                                    model: {
                                      value: _vm.selectedRecaudador,
                                      callback: function($$v) {
                                        _vm.selectedRecaudador = $$v
                                      },
                                      expression: "selectedRecaudador"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errores.recaudador_id
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.recaudador_id[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.verAuditoria,
                            expression: "verAuditoria"
                          }
                        ]
                      },
                      [
                        _vm._m(11),
                        _vm._v(" "),
                        _vm.pedido.creador != null
                          ? _c("td", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.pedido.created_at) +
                                  " (" +
                                  _vm._s(_vm.pedido.creador.nombre_usuario) +
                                  ")\n              "
                              )
                            ])
                          : _c("td"),
                        _vm._v(" "),
                        _vm._m(12),
                        _vm._v(" "),
                        _vm.pedido.modificador != null
                          ? _c("td", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.pedido.updated_at) +
                                  " (" +
                                  _vm._s(
                                    _vm.pedido.modificador.nombre_usuario
                                  ) +
                                  ")\n              "
                              )
                            ])
                          : _c("td")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.verAuditoria,
                            expression: "verAuditoria"
                          }
                        ]
                      },
                      [
                        _vm._m(13),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.pedido.fecha_cambio_estado) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(14),
                        _vm._v(" "),
                        _vm.pedido.supervisor_cambio != null
                          ? _c("td", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.pedido.supervisor_cambio.nombre_usuario
                                  ) +
                                  "\n              "
                              )
                            ])
                          : _c("td")
                      ]
                    ),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(15),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.descripcion_estado) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select" }, [
                              _c("div", { staticClass: "select-field" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.estado,
                                        expression: "form.estado"
                                      }
                                    ],
                                    attrs: { name: "estado", id: "estado" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "estado",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "P" } }, [
                                      _vm._v("Pendiente")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "I" } }, [
                                      _vm._v("Incobrable")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "F" } }, [
                                      _vm._v("Finalizado")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errores.estado
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.estado[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                      ]),
                      _vm._v(" "),
                      _vm._m(16),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.editMode
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.pedido.descripcion_estado_pago) +
                                  "\n                "
                              )
                            ])
                          : _c("div", { staticClass: "form-field select" }, [
                              _c("div", { staticClass: "select-field" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.pagada,
                                        expression: "form.pagada"
                                      }
                                    ],
                                    attrs: { name: "pagada", id: "pagada" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "pagada",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "0" } }, [
                                      _vm._v("Pendiente")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "1" } }, [
                                      _vm._v("Pagada")
                                    ])
                                  ]
                                )
                              ])
                            ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.pedido != null
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("h5", [_vm._v("Movimientos del cliente")]),
                _vm._v(" "),
                _vm.pedidoId != null && _vm.editMode
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-success",
                        attrs: { type: "button" },
                        on: { click: _vm.agregarNotaDebitoCredito }
                      },
                      [_c("i", { staticClass: "fa fa-plus" })]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _vm._m(17),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _c("tr", [
                        _vm._m(18),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.pedido.fecha) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(_vm.total)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.movimientos, function(item, index) {
                        return _c("tr", { key: index }, [
                          _c(
                            "th",
                            {
                              attrs: {
                                tooltip: item.numero_documento,
                                scope: "row"
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.total < 0 ? "(-)" : "(+)") +
                                  " " +
                                  _vm._s(item.tipo) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.fecha) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { tooltip: item.codigo_barra } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.descripcion_item) +
                                _vm._s(
                                  item.cantidad != null
                                    ? " - " + _vm.decimalFormat(item.cantidad)
                                    : ""
                                ) +
                                _vm._s(
                                  item.precio != null
                                    ? " - " + _vm.moneyFormat(item.precio)
                                    : ""
                                ) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            item.total > 0
                              ? _c("strong", [
                                  _vm._v(_vm._s(_vm.moneyFormat(item.total)))
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            item.total < 0
                              ? _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.moneyFormat(Math.abs(item.total))
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.ruta) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          item.id
                            ? _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-danger",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarNotaDebitoCredito(
                                          item.id
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-trash" })]
                                )
                              ])
                            : _c("td")
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("tfoot", [
                    _c(
                      "th",
                      {
                        staticStyle: { "font-size": "18px" },
                        attrs: { colspan: "3", scope: "row" }
                      },
                      [_vm._v("\n              Saldo final\n            ")]
                    ),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "font-size": "18px" } }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.totalDebe, 2)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "font-size": "18px" } }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.totalHaber, 2)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "font-size": "18px" } }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(
                              parseFloat(_vm.totalDebe) -
                                parseFloat(_vm.totalHaber),
                              2
                            ) /*moneyFormat(pedido.saldo_total, 2)*/
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12" }, [
              _c("h5", [_vm._v("Ítems de la venta")]),
              _vm._v(" "),
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Ítem")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Cantidad")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Precio")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Total")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Pendientes")]),
                      _vm._v(" "),
                      _c("th", [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editMode,
                                expression: "editMode"
                              }
                            ],
                            staticClass: "btn-success",
                            attrs: { type: "button" },
                            on: { click: _vm.agregarItem }
                          },
                          [_c("i", { staticClass: "fa fa-plus" })]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.form.items, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { attrs: { tooltip: item.codigo_barra } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.item.descripcion) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.decimalFormat(item.cantidad)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(item.precio)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(item.total)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                item.pendiente_verificacion === "S"
                                  ? "Sí"
                                  : "No"
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.editMode,
                                  expression: "editMode"
                                }
                              ],
                              staticClass: "btn-info btn--text",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.editarItem(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-edit" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.editMode,
                                  expression: "editMode"
                                }
                              ],
                              staticClass: "btn-danger btn--text",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.eliminarItem(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-trash" })]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editMode,
                expression: "editMode"
              }
            ],
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.actualizar }
          },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _c("span", [_vm._v("Actualizar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editMode,
                expression: "editMode"
              }
            ],
            staticClass: "btn-warning btn--text",
            attrs: { type: "button" },
            on: { click: _vm.cancelarEdicion }
          },
          [
            _c("i", { staticClass: "fa fa-ban" }),
            _vm._v("Cancelar edición\n    ")
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            on: {
              click: function($event) {
                return _vm.$emit("cerrar")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-ban" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "itemPedido",
            adaptive: "",
            reset: "",
            resizable: "",
            scrollable: "",
            width: "60%",
            clickToClose: false,
            height: "auto"
          }
        },
        [
          _c("item-pedido", {
            on: { input: _vm.inputItem, cancelar: _vm.cancelarEdicionItem },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "galeriaPedidos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            reset: "",
            resizable: ""
          }
        },
        [
          _c("galeria-pedidos", {
            on: { cerrar: _vm.cerrar },
            model: {
              value: _vm.pedido,
              callback: function($$v) {
                _vm.pedido = $$v
              },
              expression: "pedido"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "abonosPedido",
            width: "65%",
            height: "auto",
            reset: "",
            resizable: "",
            scrollable: "",
            adaptive: "",
            clickToClose: false
          }
        },
        [
          _c("abonos-pedido", {
            attrs: {
              puedeRegistrarAbonos: _vm.puedeRegistrarAbonos,
              puedeEditarAbonos: _vm.puedeEditarAbonos,
              puedeAnularAbonos: _vm.puedeAnularAbonos,
              pedidoId: _vm.pedidoId
            },
            on: { cerrar: _vm.cerrarAbonosPedido }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.pedido != null
        ? _c(
            "modal",
            {
              attrs: {
                name: "informacionCliente",
                height: "auto",
                width: "60%",
                scrollable: "",
                reset: "",
                adaptive: "",
                resizable: ""
              }
            },
            [
              _c("informacion-cliente", {
                on: {
                  cerrar: function($event) {
                    return _vm.$modal.hide("informacionCliente")
                  }
                },
                model: {
                  value: _vm.pedido.cliente,
                  callback: function($$v) {
                    _vm.$set(_vm.pedido, "cliente", $$v)
                  },
                  expression: "pedido.cliente"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "comentariosVenta",
            height: "auto",
            width: "60%",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: ""
          }
        },
        [
          _c("comentarios-venta", {
            attrs: { ventaId: _vm.pedidoId },
            on: { cerrar: _vm.cerrarComentariosVenta }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "notaDebitoCredito",
            heigth: "auto",
            width: "60%",
            reset: "",
            adaptive: ""
          }
        },
        [
          _c("nota-debito-credito", {
            attrs: { pedidoId: _vm.pedidoId },
            on: {
              cerrar: _vm.cerrarNotaDebitoCredito,
              guardar: _vm.guardarNotaDebitoCredito
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "editarCoordenadas",
            heigth: "auto",
            width: "60%",
            reset: "",
            adaptive: ""
          }
        },
        [
          _c("editar-coordenadas", {
            attrs: {
              pedidoId: _vm.pedidoId,
              latitud: _vm.pedido != null ? _vm.pedido.latitud_venta : "",
              longitud: _vm.pedido != null ? _vm.pedido.longitud_venta : ""
            },
            on: {
              cancelar: function($event) {
                return _vm.$modal.hide("editarCoordenadas")
              },
              updated: _vm.updatedCoordenadas
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "25%" } }, [
      _c("strong", [_vm._v("Fecha de venta:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "25%" } }, [
      _c("strong", [_vm._v("Día de cobro")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Vendedor:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Cliente:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Dirección del cliente:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Dirección de la venta:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Observación de modificación:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Ruta:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Supervisor:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Verificador:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Recaudador:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Creación")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Modificación")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Últ. Cambio Estado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Supervisor de cambio")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Estado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Estado de pago")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ítem")]),
        _vm._v(" "),
        _c("th", [_vm._v("Debe")]),
        _vm._v(" "),
        _c("th", [_vm._v("Haber")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ruta")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("(+) Venta")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540e646c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540e646c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/InformacionPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-540e646c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/InformacionPedido.vue
// module chunks = 0